module.exports = __webpack_public_path__ + "img/103.bf1ced9e.jpg";